import React from "react";
import { UserPlus, CreditCard, Banknote, Gift, MessageCircle } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { waLink } from "../../lib/constants";
import { Reveal } from "../Reveal";
import { Overline, SectionTitle, GoldButton } from "./Primitives";

const REFERRAL_MSG =
  "Olá! Vim pelo site e quero participar do programa Indique e Ganhe do Clube das Estrelas. Quero indicar um amigo e ganhar R$ 50 via Pix quando ele assinar.";

const STEPS = [
  { icon: UserPlus, title: "Indique um amigo", desc: "Fale com a gente no WhatsApp e passe o nome de quem você quer indicar." },
  { icon: CreditCard, title: "Ele assina o Clube", desc: "Seu amigo fecha a assinatura do Clube das Estrelas no cartão de crédito." },
  { icon: Banknote, title: "Você ganha R$ 50", desc: "Assim que a assinatura for confirmada, você recebe R$ 50 via Pix. Sem limite de indicações." },
];

export default function IndiqueGanhe({ className = "" }) {
  const { site } = useSite();
  return (
    <section className={`max-w-7xl mx-auto px-5 lg:px-8 ${className}`} data-testid="indique-ganhe-section">
      <div className="relative overflow-hidden rounded-sm border border-gold/30 bg-gradient-to-br from-gold/10 to-transparent p-8 lg:p-14">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.1fr] gap-10 lg:gap-14 items-center">
          <div>
            <Reveal>
              <Overline className="mb-3 flex items-center gap-2">
                <Gift className="w-4 h-4" /> Programa de indicação
              </Overline>
            </Reveal>
            <Reveal delay={0.05}>
              <SectionTitle>
                INDIQUE E GANHE <span className="text-gold">R$ 50</span>
              </SectionTitle>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-4 text-zinc-300 leading-relaxed max-w-md">
                Indicou um amigo e ele assinou o Clube das Estrelas no cartão de crédito? Você recebe{" "}
                <span className="text-gold font-600">R$ 50 direto no seu Pix</span> por cada novo assinante. Indique
                quantos quiser — sua recompensa não tem limite.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-7">
                <GoldButton
                  href={waLink(site, "barbearia", REFERRAL_MSG)}
                  size="lg"
                  data-testid="indique-ganhe-whatsapp-button"
                >
                  <MessageCircle className="w-5 h-5" /> QUERO INDICAR PELO WHATSAPP
                </GoldButton>
              </div>
            </Reveal>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 gap-4">
            {STEPS.map((s, i) => (
              <Reveal key={i} delay={0.1 + i * 0.08}>
                <div className="flex items-start gap-4 border border-white/10 rounded-sm p-5 bg-[#0d0d0d] hover:border-gold/50 transition-colors h-full">
                  <div className="shrink-0 w-11 h-11 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center">
                    <s.icon className="w-5 h-5 text-gold" />
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="font-heading font-700 text-gold text-sm">{i + 1}.</span>
                      <h3 className="font-heading font-600 uppercase text-white text-sm">{s.title}</h3>
                    </div>
                    <p className="text-zinc-400 text-sm mt-1.5 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
